import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface OrderByServiceReq {
  /** 权益服务key */
  permission_name?: string
}


export interface PermissionInfo {
  /** 开始时间戳,单位秒 */
  begin_time_stamp: number
  /** 过期时间戳,单位秒 */
  expires_time_stamp: number
  /** 服务期限类型 1-日、2-月、3-季、4-年 */
  date_kind: number
  /** 周期数量，比如date_kind=1，cycle_count=2，表示2年 */
  cycle_count: number
  /** 购买数量 */
  count?: number
  /** 订阅时间（时间戳） */
  create_time?: string
  /** 已使用的数量 */
  used_count?: number
}

export interface Permissions {
  product_id: string
  /** 权益服务key */
  permission_name: string
  /** 权益服务显示名称 */
  display_name: string
  permission_info: PermissionInfo
  system_types?: number[]
  is_check: boolean
}

export interface OrderByServiceRes {
  /** 订阅的服务集合 */
  permissions: Permissions[]
}

@Injectable()
export class ServiceAuthService {
  constructor (private http: Http) {
  }
}
